import { PermissionSetType, SidebarProductVisibilityPermissionSet } from '../sets'
import { RealizePermissionSet } from '../sets/RealizePermissions'
import { AdminMinimalRole } from './AdminMinimalRole'

// Ignore prettier to ensure only one permission set per line
// prettier-ignore
export const AccessToRealizeRole: PermissionSetType[] = [
  ...AdminMinimalRole,
  SidebarProductVisibilityPermissionSet.ShowRealizeProduct,
  RealizePermissionSet.Access,
]
